import React from "react";

import { Outlet } from "react-router-dom";

import "./layout.css";

interface LayoutProps {
  children?: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="layout_container">
      <div className="flex" style={{ flexGrow: "1" }}>
        <div className="main_container">{children ?? <Outlet />}</div>
      </div>
    </div>
  );
};
